import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { IDropdownItemProps } from './Dropdown.types'

const StyledDropdownItem = styled.div`
  padding: 0.5rem 1rem;
  color: ${STYLES.TEXT_COLOR};
  cursor: pointer;
  min-width: 100%;
  white-space: nowrap;
  box-sizing: border-box;
  text-align: left;
  font-size: ${STYLES.FONT_SIZE_MD};
  ${({ isSelected }: { isSelected?: boolean }) =>
    isSelected
      ? `
    background-color: ${STYLES.TEXT_COLOR};
    font-weight: ${STYLES.FONT_WEIGHT_BOLD};
    color: ${STYLES.COLOR_WHITE};
  `
      : `
    &:hover {
      color: ${STYLES.TEXT_COLOR};
      background-color: ${STYLES.COLOR_ATHENS_GRAY}
    }
  `}
  ${SCREEN_SIZE.MD} {
    padding: 0.5rem 1rem;
  }
  &:last-of-type {
    border-bottom-width: 0;
  }
`

const DropdownItem: React.FC<IDropdownItemProps> = ({
  isSelected,
  children,
  onSelect,
}) => (
  <StyledDropdownItem isSelected={isSelected} onClick={onSelect}>
    {children}
  </StyledDropdownItem>
)

export { DropdownItem }
